(() => {
  const headers = document.querySelectorAll('[data-brd-header]');
  if (!headers.length) return;

  headers.forEach((root) => {
    if (root.dataset.brdHeaderReady === 'true') return;
    root.dataset.brdHeaderReady = 'true';

    const toggle = root.querySelector('[data-brd-mobile-menu]');
    const drawer = root.querySelector('[data-brd-mobile-drawer]');
    const panel = root.querySelector('[data-brd-mobile-panel]');
    const closeControls = root.querySelectorAll('[data-brd-mobile-close]');
    const mobileQuery = window.matchMedia('(max-width: 900px)');
    let returnFocus = null;

    if (!toggle || !drawer || !panel) return;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    const close = ({ restoreFocus = true } = {}) => {
      if (drawer.hidden) return;
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('brd-mobile-nav-open');
      if (restoreFocus && returnFocus instanceof HTMLElement) returnFocus.focus();
      returnFocus = null;
    };

    const open = () => {
      if (!mobileQuery.matches || !drawer.hidden) return;
      returnFocus = document.activeElement;
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('brd-mobile-nav-open');
      panel.focus();
    };

    toggle.addEventListener('click', () => {
      if (drawer.hidden) open();
      else close();
    });

    closeControls.forEach((control) => {
      control.addEventListener('click', () => close());
    });

    drawer.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => close({ restoreFocus: false }));
    });

    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = Array.from(panel.querySelectorAll(focusableSelector));
      if (!focusable.length) {
        event.preventDefault();
        panel.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    mobileQuery.addEventListener('change', (event) => {
      if (!event.matches) close({ restoreFocus: false });
    });
  });
})();
